import React from "react";
import moment from "moment";
import { DataTableFiles } from "../files/filesDatatable";
import { Classeur } from "../../interfaces";
import CustomDialog from "../CustomDialog";
interface ModalInfoClasseurProps {
  closeModalInfo: () => void;
  modalIsOpenInfo: boolean;
  selectedClasseur: Classeur;
  isNotViewer: () => boolean;
}
const ModalInfoClasseur = ({
  closeModalInfo,
  modalIsOpenInfo,
  selectedClasseur,
  isNotViewer,
}: ModalInfoClasseurProps) => {
  return (
    <CustomDialog
      header="Informations classeur"
      visible={modalIsOpenInfo}
      closeModalDialog={() => closeModalInfo()}
      customStyle={{ width: "70vw" }}
    >
      <div className="w-full h-full">
        <div className="p-6 space-y-6">
          <div className="p-6 h-full">
            <img
              src="/images/reliures.png"
              className="mx-auto mb-4 text-gray-400 w-10 h-10 "
            />

            <h5>
              Nom : <strong>{selectedClasseur.nom_classeur}</strong>
            </h5>
            <h5>
              Projet : <strong>{selectedClasseur.projet_classeur}</strong>
            </h5>
            <h5>
              Typologie Gexpertise :{" "}
              <strong>{selectedClasseur.typologie_gexpertise}</strong>
            </h5>
            <h5>
              Typologie Fidji :{" "}
              <strong>{selectedClasseur.typologie_fidji}</strong>
            </h5>
            <h5>
              Date de création :{" "}
              <strong>
                {moment(selectedClasseur.created_at).format("MMMM Do YYYY")}
              </strong>
            </h5>
            <div className="mt-5 ">
              <DataTableFiles
                fichiers={selectedClasseur.fichiers}
                isNotViewer={isNotViewer}
              />
            </div>
          </div>
        </div>
      </div>
    </CustomDialog>
  );
};

export default ModalInfoClasseur;
